module.exports = __webpack_public_path__ + "images/3423c48c6d9b626a792ed45f84fc7095c.svg";